import { motion, useReducedMotion } from 'motion/react'

/**
 * Animation du dialog « Réservation en cours » : des documents glissent un à un
 * dans un dossier de voyage. Boucle tant que la création du dossier tourne.
 * `prefers-reduced-motion` : dossier statique, seul un léger battement d'opacité
 * signale que le traitement continue.
 */
export function ReservationLoaderAnimation() {
  const reduceMotion = useReducedMotion()

  const papers = [0, 1, 2]
  const cycle = 2.4

  return (
    <svg aria-hidden className="size-24" fill="none" viewBox="0 0 120 96">
      {/* Panneau arrière du dossier, avec onglet */}
      <path
        d="M22 32a6 6 0 0 1 6-6h18a4 4 0 0 1 2.9 1.2l5.4 5.6H92a6 6 0 0 1 6 6v34a6 6 0 0 1-6 6H28a6 6 0 0 1-6-6z"
        fill="var(--color-brand-100)"
      />

      {/* Documents qui tombent dans le dossier (entre panneau arrière et avant) */}
      {papers.map((i) => (
        <motion.g
          animate={
            reduceMotion ? { opacity: [0.35, 1, 0.35] } : { opacity: [0, 1, 1], y: [0, 26, 30] }
          }
          initial={reduceMotion ? { opacity: 0.6, y: 24 } : { opacity: 0, y: 0 }}
          key={i}
          transition={{
            delay: (i * cycle) / papers.length,
            duration: reduceMotion ? 3 : cycle,
            ease: [0.16, 1, 0.3, 1],
            repeat: Infinity,
            times: reduceMotion ? [0, 0.5, 1] : [0, 0.55, 1],
          }}
        >
          <rect
            fill="white"
            height="30"
            rx="3"
            stroke="var(--color-brand-300)"
            width="34"
            x="43"
            y="8"
          />
          <rect fill="var(--color-brand-300)" height="3" rx="1.5" width="22" x="49" y="15" />
          <rect fill="var(--color-gray-light-200)" height="3" rx="1.5" width="16" x="49" y="22" />
          <rect fill="var(--color-gray-light-200)" height="3" rx="1.5" width="19" x="49" y="29" />
        </motion.g>
      ))}

      {/* Panneau avant du dossier : occulte les documents arrivés */}
      <path
        d="M18 46a5 5 0 0 1 5-5h74a5 5 0 0 1 4.9 6l-5.2 26a6 6 0 0 1-5.9 4.8H28a6 6 0 0 1-5.9-4.9l-4-21z"
        fill="var(--color-brand-600)"
      />
      {/* Liseré du panneau avant */}
      <path
        d="M18 46a5 5 0 0 1 5-5h74a5 5 0 0 1 4.9 6l-.6 3H19.2l-.6-3z"
        fill="var(--color-brand-700)"
        opacity="0.35"
      />
    </svg>
  )
}
